import {useEffect} from "react";
import {Popover} from "@headlessui/react";

import {useDispatch, useSelector} from "react-redux";
import useAuth from "../../hooks/useAuth";
import {getSecondGrower} from "../../actions/kontoActions";

import {classNames} from "../../lib/classNames";

import BrandLogo from "../navigation/BrandLogo";
import MenuButton from "../navigation/MenuButton";
import {MobileProfileMenu, ProfileMenu} from "./ProfileMenu";

export default function Authbar({navigation}) {
  const secondGrower = useSelector((state) => state.accounts.secondGrower);
  const auth = useAuth();
  const dispatch = useDispatch();

  useEffect(() => {
    if (auth.isAuthenticated && auth.user.role === "user") {
      dispatch(getSecondGrower(auth.user.growerId));
    }
  }, [auth, dispatch]);

  return (
    <Popover
      as="header"
      className={({open}) =>
        classNames(
          open ? "fixed inset-0 z-40 overflow-y-auto" : "",
          "bg-white border-b border-primary shadow-sm lg:static lg:overflow-y-visible"
        )
      }
    >
      {({open}) => (
        <>
          <div className="px-6 py-8 max-w-7xl mx-auto sm:px-6 lg:px-8 ">
            <div className="relative flex justify-between xl:grid xl:grid-cols-12 lg:gap-8">
              <BrandLogo/>
              <div className="min-w-0 flex-1 md:px-8 lg:px-0 xl:col-span-6">
                <div className="flex items-center  md:max-w-3xl md:mx-auto lg:max-w-none lg:mx-0 xl:px-0"></div>
              </div>
              <MenuButton open={open}/>
              <ProfileMenu auth={auth} secondGrower={secondGrower}  />
            </div>
          </div>
          <MobileProfileMenu auth={auth} secondGrower={secondGrower} navigation={navigation} />
        </>
      )}
    </Popover>
  );
}
